import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectProfile } from 'screens/Login/selectors';
import {
	collectorPhotoRoute,
	loadPrivateCollectorPhoto,
} from 'services/privateCollectorPhoto';

export default function useCollectorPhotoSource({
	photoId,
	variant,
	src,
	legacySrc = src,
	active = true,
}) {
	const profile = useSelector(selectProfile);
	const route =
		process.env.REACT_APP_PRIVATE_COLLECTOR_PHOTO_ENABLED === 'true'
			? collectorPhotoRoute(src)
			: 'legacy';
	const [loaded, setLoaded] = useState(null);
	const activeLease = useRef(null);
	useEffect(() => {
		if (route !== 'private' || !active) return undefined;
		const lease = {};
		activeLease.current = lease;
		let request,
			current = true;
		try {
			request = loadPrivateCollectorPhoto({ photoId, variant });
			request.done
				.then(url => {
					if (current)
						setLoaded({ photoId, variant, src, profile, url, lease });
				})
				.catch(() => {
					if (current) setLoaded(null);
				});
		} catch (_) {
			setLoaded(null);
		}
		return () => {
			current = false;
			activeLease.current = null;
			if (request) request.cancel();
		};
	}, [route, active, photoId, variant, src, profile]);
	if (route === 'legacy') return legacySrc;
	if (
		route !== 'private' ||
		!active ||
		!loaded ||
		loaded.lease !== activeLease.current ||
		loaded.photoId !== photoId ||
		loaded.variant !== variant ||
		loaded.src !== src ||
		loaded.profile !== profile
	)
		return undefined;
	return loaded.url;
}
